"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgWifi = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M16 26h.013M30.41 11.601a21.26 21.26 0 0 0-14.41-5.6 21.26 21.26 0 0 0-14.408 5.6m4.718 4.723A14.6 14.6 0 0 1 16 12.667c3.715 0 7.107 1.38 9.69 3.657m-4.759 4.71a7.97 7.97 0 0 0-4.931-1.7 7.97 7.97 0 0 0-4.993 1.748" }))); };
exports.default = SvgWifi;
//# sourceMappingURL=Wifi.js.map